import React from "react";
import apple from '../assets/Appsecond.png';
import playStore from '../assets/googleplaysecond.png';
import { FaBell} from 'react-icons/fa'; // Social icons
import '../components/Footer.css';
import twitter from "../assets/twitter.png"
import insta from '../assets/insta.png'
import linkdin from '../assets/linkdin.png'
const Footer = () => {
  const currentYear = new Date().getFullYear(); // Dynamic Year

  return (
    <div>
      {/* Upper Footer: Download Now Section */}
      <div className="upperFooter">
        <h1>Download Now</h1>
        <p>Available for iOS and Android</p>
        <a href="https://www.apple.com/app-store/" target="_blank" className="btn">
          <img src={apple} alt="App Store" />
        </a>
        <a href="https://play.google.com/store" target="_blank" className="btn">
          <img src={playStore} alt="Google Play" />
        </a>
      </div>

      {/* Lower Footer: Bell Icon and Text with Social Icons */}
      <div className="lowerFooter">
        <div className="left-footer">
          {/* Bell icon and text */}
          <FaBell style={{ color: "#4285F4", fontSize: "24px" }} />
          <span className="bell-text">NeverMissADose</span>
        </div>

        {/* Right side - Social Media Links */}
        <div className="right-footer">
          
          <a href="https://twitter.com/nevermissadose_" target="_blank" rel="noopener noreferrer">
            <img src={twitter}/>
          </a>
          <a href="https://www.instagram.com/nevermissadose?igsh=dHV2cHFweHo5Ynlz" target="_blank" rel="noopener noreferrer">
           <img src={insta}/>
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
             <img src={linkdin}/>
          </a>
         
        </div>
      </div>

      {/* Footer Bottom - Copyright Text and Privacy Links */}
      <div className="footer-bottom">
        <p>© {currentYear} NeverMissADose. All rights reserved.</p>
        <div className="privacy">
          <a href="/privacy-policy">Privacy Policy</a>
          <span>|</span>
          <a href="/terms">Terms of Service</a>
        </div>
      </div>
      <div className="developer-credit">
        <p>Developed by RVKCS AI Services pvt ltd</p>
      </div>
    </div>
  );
}

export default Footer;



